import { linkBudgetService } from '@/services/link_budget/link_budget'
import type {
  ILinkBudgetPayloadData
} from '@/services/link_budget/link_budget.types'
import { defineStore } from 'pinia'
import type { ILinkBudgetState } from './link-budget.types'


export const useLinkBudgetStore = defineStore('linkBudget', {
  state: (): ILinkBudgetState => ({
    result: null
  }),

  actions: {
    async calculateLinkBudget(payload: ILinkBudgetPayloadData) {
      const result = await linkBudgetService.calculateLinkBudget(payload)
      this.result = {
        ...result,
        connection: result.qos !== 'No connection possible',
        rx_sensitivity: Math.round(result.rx_sensitivity),
        expectedRSSI: Math.round(result.expectedRSSI)
      }
    },

    async resetCalculation() {
      this.result = null
    }
  }
})